"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var react_native_2 = require("react-native");

var theme_1 = require("../../../theming/theme");

var PharmacySelector = function (_super) {
  __extends(PharmacySelector, _super);

  function PharmacySelector() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderPharmacySelectorItems = function () {
      return _this.props.pharmacyList.map(function (pharmacy) {
        return react_1.default.createElement(react_native_2.Picker.Item, {
          label: pharmacy.name,
          value: pharmacy.id,
          key: pharmacy.id
        });
      });
    };

    _this.handleOnPharmacyChange = function (id) {
      _this.props.onChangePharmacy(id);
    };

    return _this;
  }

  PharmacySelector.prototype.render = function () {
    return react_1.default.createElement(react_native_1.View, {
      style: styles.pickerView
    }, react_1.default.createElement(react_native_1.Text, {
      style: styles.titleText
    }, "Pharmacy Group"), react_1.default.createElement(react_native_2.Picker, {
      selectedValue: undefined,
      style: styles.pharmacySelector,
      onValueChange: this.handleOnPharmacyChange
    }, this.renderPharmacySelectorItems()));
  };

  return PharmacySelector;
}(react_1.default.Component);

exports.PharmacySelector = PharmacySelector;
var pharmacyNameText = {
  fontSize: 48,
  fontStyle: 'italic',
  fontWeight: '800'
};
var pharmacySelector = {
  backgroundColor: theme_1.GreyScale.lightest,
  borderColor: theme_1.PurpleScale.darkest,
  borderRadius: 0,
  borderWidth: 4,
  height: 50,
  padding: 10
};
var titleText = {
  color: theme_1.PurpleScale.darker,
  fontSize: 36,
  fontWeight: '100',
  margin: 10
};
var pickerView = {
  flex: 1,
  minWidth: 500,
  paddingHorizontal: 5
};
var styles = react_native_1.StyleSheet.create({
  pharmacyNameText: pharmacyNameText,
  pharmacySelector: pharmacySelector,
  pickerView: pickerView,
  titleText: titleText
});